var _ = require('./lodash.min').runInContext();
module.exports = require('./fp/_baseConvert')(_, _);



//////////////////
// WEBPACK FOOTER
// ./~/lodash/fp.js
// module id = 492
// module chunks = 263791100135453